import { useState } from 'react';

const LOCALE = 'vi-VN';

export const useInputPrice = (initialValue = '') => {
  const [value, setValue] = useState(initialValue);

  const displayValue =
    value === '' ? '' : Number(value).toLocaleString(LOCALE);

  const handleChange = (e) => {
    const inputValue = e.target.value;
    const parsedValue = Number(inputValue.replace(/[^0-9]/g, ''));
    setValue(parsedValue === 0 ? '' : parsedValue);
  };

  return {
    value,
    displayValue,
    onChange: handleChange,
  };
};
